import * as captchaApi from '~/api/captcha'

export async function getCaptchaId() {
  const key = 'scm_captcha'
  let content = localStorage.getItem(key)
  let data = safeParseJson(content)
  if (!data) {
    data = await captchaApi.getId({})
    localStorage.setItem(key, JSON.stringify(data))
    return data.Id
  }

  const { Id, Expires } = data
  const expires = new Date(Expires)
  const now = new Date()
  const ticks = expires - now
  const minTicks = 60 * 2 * 1000
  if (ticks < minTicks) {
    data = await captchaApi.getId({ Id })
    localStorage.setItem(key, JSON.stringify(data))
  }

  return Id
}

function safeParseJson(content) {
  try {
    if (!content) {
      return null
    }

    return JSON.parse(content)
  } catch {
    return null
  }
}

export async function getImageUrl() {
  const id = await getCaptchaId()
  const ts = Date.now()
  return `/api/Captcha/GetImage?Id=${id}&t=${ts}`
}
